const config =
    "#.........DO NOT MODIFY BY HAND .........................\n" +
    "[ ca ]\n" +
    "default_ca               = CA_default\n" +
    "[ CA_default ]\n" +
    "dir                      = %%ROOT_FOLDER%%            # the main CA folder\n" +
    "certs                    = $dir/certs                 # where to store certificates\n" +
    "new_certs_dir            = $dir/certs                 #\n" +
    "database                 = $dir/index.txt             # the certificate database\n" +
    "serial                   = $dir/serial                # the serial number counter\n" +
    "certificate              = $dir/public/cacert.pem     # The root CA certificate\n" +
    "private_key              = $dir/private/cakey.pem     # the CA private key\n" +
    "x509_extensions          = usr_cert                   #\n" +
    "default_days             = 3650                       # default validity : 10 years\n" +
    "\n" +
    "# default_md               = sha1\n" +
    "\n" +
    "default_md                = sha256                      # The default digest algorithm\n" +
    "\n" +
    "preserve                 = no\n" +
    "policy                   = policy_match\n" +
    "# randfile                 = $dir/random.rnd\n" +
    "# default_startdate        = YYMMDDHHMMSSZ\n" +
    "# default_enddate          = YYMMDDHHMMSSZ\n" +
    "crl_dir                  = $dir/crl\n" +
    "crl_extensions           = crl_ext\n" +
    "crl                      = $dir/revocation_list.crl # the Revocation list\n" +
    "crlnumber                = $dir/crlnumber           # CRL number file\n" +
    "default_crl_days         = 30\n" +
    "default_crl_hours        = 24\n" +
    "#msie_hack\n" +
    "\n" +
    "[ policy_match ]\n" +
    "countryName              = optional\n" +
    "stateOrProvinceName      = optional\n" +
    "localityName             = optional\n" +
    "organizationName         = optional\n" +
    "organizationalUnitName   = optional\n" +
    "commonName               = optional\n" +
    "emailAddress             = optional\n" +
    "\n" +
    "[ req ]\n" +
    "default_bits             = 4096                     # Size of keys\n" +
    "default_keyfile          = key.pem                  # name of generated keys\n" +
    "distinguished_name       = req_distinguished_name\n" +
    "attributes               = req_attributes\n" +
    "x509_extensions          = v3_ca\n" +
    "#input_password\n" +
    "#output_password\n" +
    "string_mask              = nombstr                  # permitted characters\n" +
    "req_extensions           = v3_req\n" +
    "\n" +
    "[ req_distinguished_name ]\n" +
    "\n" +
    "#0 countryName             = Country Name (2 letter code)\n" +
    "# countryName_default     = FR\n" +
    "# countryName_min         = 2\n" +
    "# countryName_max         = 2\n" +
    "# stateOrProvinceName     = State or Province Name (full name)\n" +
    "# stateOrProvinceName_default = Ile de France\n" +
    "# localityName            = Locality Name (city, district)\n" +
    "# localityName_default    = Paris\n" +
    "organizationName          = Organization Name (company)\n" +
    "organizationName_default  = NodeOPCUA\n" +
    "# organizationalUnitName  = Organizational Unit Name (department, division)\n" +
    "# organizationalUnitName_default = R&D\n" +
    "commonName                = Common Name (hostname, FQDN, IP, or your name)\n" +
    "commonName_max            = 256\n" +
    "commonName_default        = NodeOPCUA\n" +
    "# emailAddress            = Email Address\n" +
    "# emailAddress_max        = 40\n" +
    "# emailAddress_default    = node-opcua (at) node-opcua (dot) com\n" +
    "\n" +
    "[ req_attributes ]\n" +
    "#challengePassword        = A challenge password\n" +
    "#challengePassword_min    = 4\n" +
    "#challengePassword_max    = 20\n" +
    "#unstructuredName         = An optional company name\n" +
    "[ usr_cert ]\n" +
    "basicConstraints          = critical, CA:FALSE\n" +
    "subjectKeyIdentifier      = hash\n" +
    "authorityKeyIdentifier    = keyid,issuer:always\n" +
    "#authorityKeyIdentifier    = keyid\n" +
    "subjectAltName            = $ENV::ALTNAME\n" +
    "# issuerAltName            = issuer:copy\n" +
    "nsComment                 = ''OpenSSL Generated Certificate''\n" +
    "#nsCertType               = client, email, objsign for ''everything including object signing''\n" +
    "#nsCaRevocationUrl        = http://www.domain.dom/ca-crl.pem\n" +
    "#nsBaseUrl                =\n" +
    "#nsRenewalUrl             =\n" +
    "#nsCaPolicyUrl            =\n" +
    "#nsSslServerName          =\n" +
    "keyUsage                  = critical, digitalSignature, nonRepudiation," +
    " keyEncipherment, dataEncipherment, keyAgreement\n" +
    "extendedKeyUsage          = critical,serverAuth ,clientAuth\n" +
    // Opt-in CRL Distribution Points and Authority Information Access.
    // Emitted only when CertificateAuthority.setCrlDistributionUrl /
    // setOcspResponderUrl / setCaIssuersUrl have been called — the
    // conditional blocks are stripped by generateStaticConfig() when
    // the matching env var is unset.  See US-202.
    "{{#CDP_URL}}crlDistributionPoints     = URI:$ENV::CDP_URL\n{{/CDP_URL}}" +
    "{{#AIA_VALUE}}authorityInfoAccess       = $ENV::AIA_VALUE\n{{/AIA_VALUE}}" +
    "\n" +
    "[ v3_req ]\n" +
    "basicConstraints          = critical, CA:FALSE\n" +
    "keyUsage                  = nonRepudiation, digitalSignature, keyEncipherment, dataEncipherment, keyAgreement\n" +
    "extendedKeyUsage          = critical,serverAuth ,clientAuth\n" +
    "subjectAltName            = $ENV::ALTNAME\n" +
    'nsComment                 = "CA Generated by Node-OPCUA Certificate utility using openssl"\n' +
    "[ v3_ca_req ]\n" +
    // -----------------------------------------------------------------------
    // v3_ca_req is used ONLY during the CSR step (`openssl req -new
    // -extensions v3_ca_req`).  At that stage no issuer certificate
    // exists yet (we are bootstrapping the root CA), so we must NOT
    // include `authorityKeyIdentifier` here.
    //
    // OpenSSL 3.5.x (Alpine) rejects *any* authorityKeyIdentifier
    // value during CSR generation — even plain `keyid` — because
    // v3_akid.c unconditionally looks for an issuer certificate:
    //
    //   v3_akid.c:156: no issuer certificate
    //
    // The authorityKeyIdentifier is properly added during the
    // self-signing step (`openssl x509 -req -extensions v3_ca`)
    // where the issuer key is available.
    //
    // Tested with:
    //   - OpenSSL 3.0.x  (Ubuntu)   — works
    //   - OpenSSL 3.4.1  (Windows)  — works
    //   - OpenSSL 3.5.5  (Alpine)   — works (only with this fix)
    //
    // References:
    //   - https://github.com/openssl/openssl/issues/21519
    //   - OpenSSL man x509v3_config(5) – authorityKeyIdentifier
    // -----------------------------------------------------------------------
    "subjectKeyIdentifier      = hash\n" +
    "basicConstraints          = CA:TRUE\n" +
    "keyUsage                  = critical, cRLSign, keyCertSign\n" +
    "subjectAltName            = $ENV::ALTNAME\n" +
    'nsComment                 = "CA CSR generated by Node-OPCUA Certificate utility using openssl"\n' +
    "[ v3_ca ]\n" +
    "subjectKeyIdentifier      = hash\n" +
    "authorityKeyIdentifier    = keyid:always,issuer:always\n" +
    "basicConstraints          = CA:TRUE\n" +
    "keyUsage                  = critical, cRLSign, keyCertSign\n" +
    // OPC UA validators (UaExpert, ANSI compliance tools) flag a missing
    // SubjectAltName on the CA cert. Pull it from the ALTNAME env var
    // populated by construct_CertificateAuthority.
    "subjectAltName            = $ENV::ALTNAME\n" +
    'nsComment                 = "CA Certificate generated by Node-OPCUA Certificate utility using openssl"\n' +
    "#nsCertType                 = sslCA, emailCA\n" +
    "#issuerAltName              = issuer:copy\n" +
    "#obj                        = DER:02:03\n" +
    // Opt-in CDP / AIA on the CA cert itself (US-202).  Previously a
    // hardcoded http://localhost:8900/crl.pem was emitted unconditionally
    // — which produced broken certs in any deployment outside dev.
    "{{#CDP_URL}}crlDistributionPoints     = URI:$ENV::CDP_URL\n{{/CDP_URL}}" +
    "{{#AIA_VALUE}}authorityInfoAccess       = $ENV::AIA_VALUE\n{{/AIA_VALUE}}" +
    "[ v3_selfsigned]\n" +
    "basicConstraints          = critical, CA:FALSE\n" +
    "keyUsage                  = nonRepudiation, digitalSignature, keyEncipherment, dataEncipherment, keyAgreement\n" +
    "extendedKeyUsage          = critical,serverAuth ,clientAuth\n" +
    'nsComment                 = "Self-signed certificate, generated by NodeOPCUA"\n' +
    "subjectAltName            = $ENV::ALTNAME\n" +
    "\n" +
    "[ crl_ext ]\n" +
    "#issuerAltName            = issuer:copy\n" +
    "authorityKeyIdentifier    = keyid:always,issuer:always\n" +
    "#authorityInfoAccess       = @issuer_info";

export default config;
